import { createContext, useContext } from 'react';
import { initialState } from 'components/dashboard/quiz/newAptitude/utils/types';
//TO DO: Find less hacky solution

const newAptitudeResponsesInitialState: initialState = {
  overallTimeLeft: { minutes: 0, seconds: 0 },
  categoryTimeLeft: { minutes: 0, seconds: 0 },
  currentQuestion: 0,
  responses: {},
  totalQuestions: 0,
  currentCategoryNo: 0,
  tabSwitchedCount: 0,
};
const NewAptitudeTestResponsesContextObject: {
  state: initialState;
  dispatch: Function;
} = {
  state: newAptitudeResponsesInitialState,
  dispatch: () => {},
};

export const NewAptitudeTestResponsesContext = createContext(
  NewAptitudeTestResponsesContextObject
);

const useNewAptitudeTestResponsesContext = () => {
  return useContext(NewAptitudeTestResponsesContext);
};

export default useNewAptitudeTestResponsesContext;
